module.exports = __webpack_public_path__ + "img/e586829.png";